<template>
  <v-row justify="center"
    align="center"
    class="control-toolbar oct-toolbar secondary"
    no-gutters>
    <v-col :cols="this.isLandscape ? 3 : 'auto'" class="mr-3 pt-2">
      <select-with-button
        :value="selectedDropdownItem"
        @change="selectImage"
        :items="octDropdownItems"
        item-value="flSrNo"
        :icon-button="true"
        item-text="octDateButtonText"
        class="toolbar-select"/>
    </v-col>
    <od-os-buttons class="pt-2"
      :eye="currentEye"
      @selectOD="selectOD"
      @selectOS="selectOS" />
    <v-spacer/>
    <v-col :cols="this.isLandscape ? 2 : 'auto'" class="pt-1">
      <v-btn text @click="multiView" class="multiview-button">
        <v-avatar size="30" class="mr-1">
          <img :src="require('../../../assets/' + coloredAssetUrls.multiview)" />
        </v-avatar>Multiview
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import selectWithButton from "../../controls/SelectWithButton";
import odOsButtons from "../controls/OdOsButtons";
import { EyeTypes } from "../../../config/config";
import { mapGetters } from "vuex";
export default {
  name: "octToolbar",
  components: { selectWithButton, odOsButtons },
  props: {
    isSpectralis: Boolean
  },
  computed: {
    ...mapGetters([
      "octDropdownItems",
      "selectedDropdownItem",
      "currentEye",
      "octDataLoading",
      "widthLandscape",
      "imageByFlSrNo"
    ]),
    isOD() {
      return this.currentEye === EyeTypes.OD;
    },
    isLandscape() {
      return this.widthLandscape;
    }
  },
  methods: {
    selectImage(flSrNo) {
      if (!this.octDataLoading) {
        let image = this.imageByFlSrNo(flSrNo);
        this.$store.dispatch("openBrowserForImage", image);
      }
    },
    selectOD() {
      if (!this.octDataLoading) this.$store.dispatch("selectOCTEye", "OD");
    },
    selectOS() {
      if (!this.octDataLoading) this.$store.dispatch("selectOCTEye", "OS");
    },
    multiView() {
      if (!this.octDataLoading) this.$store.dispatch("toggleOCTMultiview");
    }
  }
};
</script>